import { useQuery } from "@tanstack/react-query";
import { getGroups } from "../../../services/groupServices";
import GroupManager from "../../../components/admin/messages/GroupManager";

export default function Groups() {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["groups"],
    queryFn: getGroups,
    retry: false,
  });

  if (isError) {
    return (
      <div>
        <p className="text-red-500">
          Error: {error?.message || "Failed to fetch groups"}
        </p>
        <button onClick={() => refetch()}>Retry</button>
      </div>
    );
  }

  return <GroupManager users={data?.data ?? []} refreshGroups={refetch} />;
}
